export default {
  content: {
    id: 'product_jp_product_condition_body_carousel_premium_content',
    defaultMessage: 'Best quality product available on Back Market.',
  },
  pill1: {
    id: 'product_jp_product_condition_body_carousel_premium_pill_1',
    defaultMessage: 'Best quality',
  },
  pill2: {
    id: 'product_jp_product_condition_body_carousel_premium_pill_2',
    defaultMessage: '{brand} verified parts',
  },
  pill3: {
    id: 'product_jp_product_condition_body_carousel_premium_pill_3',
    defaultMessage: '90~100% battery capacity guarantee',
  },
  grade: {
    id: 'product_jp_grade_9',
    defaultMessage: 'Premium',
  },
}
